import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { PasswordInput } from "./PasswordInput";

export const ChangePasswordForm = ({ onDone }) => {
  const { login } = useAuth();
  const [f, setF] = useState({ current: "", next: "", again: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (f.next.length < 8) return setErr("New password must be at least 8 characters");
    if (f.next !== f.again) return setErr("The new passwords do not match");
    setBusy(true);
    try {
      const r = await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Password changed");
      setF({ current: "", next: "", again: "" });
      await login(r.data);
      onDone?.();
    } catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="space-y-3" data-testid="change-password-form">
      <label className="block text-xs font-semibold text-slate-600">Current password
        <PasswordInput value={f.current} onChange={(v) => setF({ ...f, current: v })} testid="cp-current" /></label>
      <label className="block text-xs font-semibold text-slate-600">New password (at least 8 characters)
        <PasswordInput value={f.next} onChange={(v) => setF({ ...f, next: v })} autoComplete="new-password" testid="cp-new" /></label>
      <label className="block text-xs font-semibold text-slate-600">New password again
        <PasswordInput value={f.again} onChange={(v) => setF({ ...f, again: v })} autoComplete="new-password" testid="cp-again" /></label>
      {err && <div className="rounded-md border border-rose-200 bg-rose-50 p-2.5 text-sm text-rose-700" data-testid="cp-error">{err}</div>}
      <Button type="submit" disabled={busy || !f.current || !f.next} className="h-11 w-full sm:w-auto" data-testid="cp-submit">Change password</Button>
    </form>
  );
};
